import { useState, useEffect } from 'react';

// material-ui
import {
    Button,
    Grid
} from '@mui/material';

// project imports
import PriceList from './PriceList';
import AddPrice from './AddPrice';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

// assets
import AddIcon from '@mui/icons-material/Add';

export default function Price({ venueUuid, sportsTypes }) {

    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [selectedPrice, setSelectedPrice] = useState(null);

    const handleClickOpen = (priceUuid) => {
        if (priceUuid) {
            getPriceByUuidApi.execute(priceUuid);
        } else {
            setOpen(true);
        }
    };

    const handleClose = () => {
        setSelectedPrice(null);
        setOpen(false);
    };

    const getPriceListHandler = (response) => {
        const data = response.data;
        setRows(data.rows);
    };

    const getPriceHandler = (response) => {
        setSelectedPrice(response.data);
        setOpen(true);
    };


    const getPriceListApi = useApi(VenueService.getPriceList, getPriceListHandler);
    const getPriceByUuidApi = useApi(VenueService.getPriceByUuid, getPriceHandler);

    useEffect(() => {
        getPriceListApi.execute({ venueUuid });
    }, [reload]);

    return (
        <>
            <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                <Grid item xs={12} sm={12} sx={{ textAlign: 'right' }}>
                    <Button startIcon={<AddIcon />} variant='contained' onClick={() => handleClickOpen()} color='secondary'>Add New Price</Button>
                </Grid>
            </Grid>
            <PriceList rows={rows} setReload={setReload} handleClickOpen={handleClickOpen} />
            <AddPrice selectedPrice={selectedPrice} open={open} handleClose={handleClose} setReload={setReload} venueUuid={venueUuid} sportsTypes={sportsTypes} />
        </>
    );
};